import React, { useState, useEffect, useContext } from 'react';
import { ComponentProps } from '../../organisms/RFPComponent/RFPComponent.types';
import { Styled } from './index.styles';
import { serverData } from '../../organisms/RFPComponent/context';
import { iprops, PropertiesDefaultObjectData, PropOfIntrest, Regions } from './index.types';
import { DropDownComponent } from '../DropDownComponent';
import clsx from 'clsx';

export const Properties: React.FC<iprops> = (props: iprops) => {
  const { jsonContent }: ComponentProps = useContext(serverData);
  const defaultOption = { key: '', value: '' };
  const defaultOptions: PropertiesDefaultObjectData[] = [];
  let propertiesOfInterestDDValue: Regions['hotelsList'] = [];
  let emptyArr = [1, 2, 3];
  emptyArr.forEach(() => {
    defaultOptions.push(defaultOption);
  });

  const [hotels, setHotels] = useState(defaultOptions);
  const onClear = (flag: boolean) => {
    if (flag) {
      emptyArr = [1, 2, 3];
      setHotels(defaultOptions);
    }
  };

  if (jsonContent?.['instance']?.propertiesOfInterest?.hotelList) {
    propertiesOfInterestDDValue = jsonContent?.['instance']?.propertiesOfInterest?.hotelList.map(
      (i: { marshaCode: string; hotelName: string; shortTitle?: string }) => {
        return {
          key: i.marshaCode,
          value: i.shortTitle,
        };
      }
    );
  } else if (jsonContent?.['instance']?.propertiesOfInterest?.regions) {
    propertiesOfInterestDDValue = jsonContent?.['instance']?.propertiesOfInterest?.regions.map((item: Regions) => {
      return {
        key: item.regionId,
        value: item.region,
        yachts: item.yachts,
        subList: item.hotelsList.map(list => {
          return {
            key: list.marshaCode,
            value: list.shortTitle,
          };
        }),
      };
    });
  }

  useEffect(() => {
    onClear(props.onClear);
  }, [props.data, props.onClear]);

  return (
    <Styled data-component-name="m-trc-Properties" data-testid="trc-Properties">
      <div>
        <p className="mb-md-5 mb-xl-2 pb-2 pb-md-3 pt-5 t-title-alt-s t-rc-italic">
          {props.index}.{jsonContent?.['instance']?.propertiesOfInterest?.name}
        </p>
        <div className="properties-of-interest offset-xl-2 row d-flex flex-wrap pb-md-5">
          {jsonContent?.['instance']?.propertiesOfInterest?.fieldSet?.map((item: PropOfIntrest, index: number) => {
            return (
              <DropDownComponent
                className={clsx('mb-md-5 mb-xl-0', `rfp-${item?.name}`)}
                dropdownName={item?.fieldName}
                dropdownLabel={item?.fieldName}
                mandatory={item?.mandatory}
                dropdownPlaceholder={`${item?.placeholder ?? 'Select'}`}
                key={item?.name}
                panelClassName="dropdown-panel"
                disabled={props.submitted}
                dropdownValue={propertiesOfInterestDDValue}
                inputValue={hotels[index]?.value}
                isError={props?.data[index]?.isError}
                errorMessage={item?.errorMessage}
                selectedOption={hotels[index]}
                onClick={(v: { key?: string; value?: string }) => {
                  const hotelsDup = JSON.parse(JSON.stringify(hotels));
                  hotelsDup[index] = v;
                  setHotels(hotelsDup);
                  props.onDataChange({
                    key: item?.name,
                    value: v,
                  });
                }}
                isTabletView={props?.isTabletView}
                iconAriaLabel={`select your option in ${item?.name + ' ' + index}`}
              />
            );
          })}
        </div>
      </div>
    </Styled>
  );
};
